module.exports = function () {
    if ($('.parallax-module__parallax-block').length) {

        var speed = 112;
        var maxDistance = 112 * 2;
        var multiplier = 1;

        var calculateParallax = function () {
            $('.parallax-module__parallax-block:not(.parallax-module__parallax-block--full-width):not(.parallax-module__parallax-block--full-height):not(.parallax-module__parallax-block--pinned)').each(function () {
                var $parallaxElement = $(this);
                var boundingClientRect = $parallaxElement[0].getBoundingClientRect();
                var midpointOfElement = boundingClientRect.top -
                    parseInt($parallaxElement.css('top')) +
                    boundingClientRect.height / 2;
                var midpointOfScreen = window.innerHeight / 2;

                var distanceFromMidpoint = midpointOfScreen - midpointOfElement;
                var offset = distanceFromMidpoint / window.innerHeight * (-speed * multiplier);

                if (offset < 0) {
                    offset = Math.max(offset, -maxDistance);
                }
                else {
                    offset = Math.min(offset, maxDistance);
                }

                var translatedOffset = "translateY(" + offset + "px)";
                
                $parallaxElement.css('transform', translatedOffset);
            });
        };

        $(window).scroll(function () {
            requestAnimationFrame(calculateParallax);
        });

        calculateParallax();

        var $squareParallaxBlocks = $('.parallax-module__parallax-block--square');

        var makeBoxesSquare = function () {
            if (ICF.Utils.Breakpoints.IsAtLeastTablet()) {
                $squareParallaxBlocks.each(function () {
                    var height = $(this).find('.parallax-module__parallax-block__inner').height();
                    var width = $(this).width();

                    if (height < width) {
                        $(this).css('height', (width + 'px'));
                    } else {
                        $(this).css('height', '');
                    }
                });
            }
            else {
                $squareParallaxBlocks.css('height', '');
            }
        };

        if ($squareParallaxBlocks.length) {
            makeBoxesSquare();

            $(window).resize(function () {
                makeBoxesSquare();
            });
        }

        var $absolutePositionedParallaxBlocks = $('.parallax-module__parallax-block--full-width, .parallax-module__parallax-block--pinned');
        var $contentHeightBlocks = $('.parallax-module__container--content-height');

        var adjustContentHeightBlocks = function () {
            if (ICF.Utils.Breakpoints.IsMobile()) {
                $contentHeightBlocks.css('height', '');
            }
            else {
                $absolutePositionedParallaxBlocks.each(function () {
                    var $block = $(this);

                    var $parent = $block.closest('.parallax-module__container--content-height');

                    if ($parent.length) {
                        var blockHeight = $block.outerHeight(true);

                        $parent.css('height', (blockHeight + 'px'));
                    }
                });
            }
        };

        if ($absolutePositionedParallaxBlocks.length && $contentHeightBlocks.length) {
            adjustContentHeightBlocks();

            $(window).resize(function() {
                requestAnimationFrame(adjustContentHeightBlocks);
            });
        }
    }
};